import { createThirdwebClient } from 'thirdweb';

const thirdwebClientId = '20bc4009121c478906dade53c60ef526';

export const client = createThirdwebClient({
  clientId: thirdwebClientId,
});
